import { env } from "@papier/env/env-frontend";
import { adminClient, organizationClient, twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: env.VITE_SERVERSIDE_HOST,
  plugins: [organizationClient(), adminClient(), twoFactorClient()],
});

export const { signOut, useSession, useListOrganizations, useActiveOrganization } = authClient;
